import { render } from "./User_mini.vue?vue&type=template&id=5f64ac21&scoped=true"
import script from "./User_mini.vue?vue&type=script&lang=js"
export * from "./User_mini.vue?vue&type=script&lang=js"

import "./User_mini.vue?vue&type=style&index=0&id=5f64ac21&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f64ac21"]])

export default __exports__